/**
 * Integration-related Supabase queries
 * Pure async functions - no React, no useQuery
 */

import { supabase } from "@/integrations/supabase/client";

// Types
export interface Integration {
  integration_type: string;
  is_active: boolean;
  config: Record<string, any>;
}

/**
 * Get all integrations for a company
 */
export async function getIntegrations(companyId: string): Promise<Integration[]> {
  if (!companyId) return [];

  const { data, error } = await supabase
    .from("company_integrations")
    .select("integration_type, is_active, config")
    .eq("company_id", companyId);

  if (error) throw error;
  return (data as Integration[]) || [];
}

/**
 * Get a specific integration by type
 */
export async function getIntegrationByType(companyId: string, integrationType: string): Promise<Integration | null> {
  if (!companyId || !integrationType) return null;

  const { data, error } = await supabase
    .from("company_integrations")
    .select("integration_type, is_active, config")
    .eq("company_id", companyId)
    .eq("integration_type", integrationType)
    .single();

  if (error) {
    if (error.code === 'PGRST116') return null;
    throw error;
  }

  return data as Integration;
}
